import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DDD",
      d: "M8.73 3.756a5.524 5.524 0 0 0-5.948 4.593l-.06.362a5.92 5.92 0 0 0 .223 2.846l.106.32A7.277 7.277 0 0 0 4.81 14.72l1.437 1.437 4.263 3.488a2.75 2.75 0 0 0 3.482 0l4.263-3.488 1.437-1.437a7.278 7.278 0 0 0 1.758-2.844l.106-.32a5.92 5.92 0 0 0 .224-2.846l-.06-.362a5.524 5.524 0 0 0-8.291-3.829l-1.178.707-1.178-.707a5.523 5.523 0 0 0-2.342-.764Z"
    }, null, -1)
  ]))]))
}
export default { render: render }